// extracted by mini-css-extract-plugin
export default {"content":"ApptPage_content__jb+aH","patientsList":"ApptPage_patientsList__iLOz-"};